import classnames from 'classnames';
import styles from './FundInformation.module.scss';
import { ReactElement } from 'react';

export interface FundInformationProps {
  fundInformation: { title: string; icon: ReactElement; text: string | ReactElement }[];
  preview?: boolean;
}

export const FundInformation = ({ fundInformation, preview }: FundInformationProps) => {
  return (
    <div className={styles.fundInformationContainer}>
      {fundInformation.map(({ title, icon, text }, index) => (
        <div
          className={classnames(
            styles.fundInformationItem,
            preview && styles.fundInformationItemPreview,
          )}
          key={index}
        >
          <span>{title}</span>
          <div className={styles.iconText}>
            {icon}
            <span>{text}</span>
          </div>
        </div>
      ))}
    </div>
  );
};
